// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"447":"9fdbccf3","453":"a23c2280","967":"202cb189"}[chunkId] + ".chunk.js";
};